import TrendChartWrapper from "./TrendChartWrapper";

export default TrendChartWrapper;
